module.exports = __webpack_public_path__ + "static/img/banner4View.14151051.jpg";